module.exports = __webpack_public_path__ + "static/media/gpl-logo.59da77b9.svg";